import { memo, useContext } from "react";
import { AppConfigContext } from "../../core/AppConfigContext";
import { DateUtilsContext } from "../../core/DateUtilsContext";
import { BaseDateTimeRendererProps } from "./types";

export type DateRendererProps = BaseDateTimeRendererProps;

export const DateRenderer = memo<DateRendererProps>(({ value, dateFormat, timeZone }) => {
  const appConfig = useContext(AppConfigContext);
  const { formatDateString } = useContext(DateUtilsContext);

  return (
    <>
      {formatDateString(value, dateFormat || appConfig?.dateFormat, timeZone || appConfig?.timeZone)}
    </>
  );
});
